import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconBarcode = createIcon({
  displayName: 'IconBarcode',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M4 5H2V19H4V5ZM7 5H6V19H7V5ZM20 5H22V19H20V5ZM15 5H9V19H15V5ZM17 5H18V19H17V5Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
